export default "__VITE_ASSET__C4RRi4zA__"